import React from 'react';
import { bool, func, number, string } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MessageHolder from 'components/messages/MessageHolder';

function RefreshRankingsConfirmMessage({ visible, selectedCount, remaining, resetDate, onProceed, onClose }) {
    if (!visible) {
        return null;
    }

    return (
        <MessageHolder onClose={onClose}>
            <div className="mg-modal-header is-info">
                <FontAwesomeIcon icon="sync" aria-label="Refresh rankings" />
            </div>
            <div className="mg-modal-content">
                <h3 className="font-30 uk-text-bold color-black">Refresh rankings</h3>
                <p className="uk-margin-top font-18">
                    We will provide you with the latest ranking data for{' '}
                    <strong>{selectedCount} keyword{selectedCount !== 1 ? 's' : ''}</strong> right now.
                </p>
                <p className="uk-margin-top font-18">
                    This will consume{' '}
                    <strong>{selectedCount}/{remaining} on-demand rank scans</strong> you currently have.
                </p>
                <p className="uk-margin-top font-18">
                    Limits will reset on <strong>{resetDate}</strong>
                </p>
                <div>
                    <button
                        className="uk-width-1-1 mg-btn is-blue is-small mg-margin-t-10"
                        onClick={onProceed}
                        type="button"
                    >
                        Refresh now
                    </button>
                    <button
                        className="uk-width-1-1 mg-btn is-white is-small mg-margin-t-10"
                        onClick={onClose}
                        type="button"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </MessageHolder>
    );
}

RefreshRankingsConfirmMessage.propTypes = {
    visible: bool.isRequired,
    selectedCount: number.isRequired,
    remaining: number.isRequired,
    resetDate: string.isRequired,
    onProceed: func.isRequired,
    onClose: func.isRequired,
};

export default RefreshRankingsConfirmMessage;
